import React, { useEffect, useState } from 'react';

const ShowAnalysisStep = ({ todo, onButtonClicked, onStepClick, selectedStep }) => {
  const [steps, setSteps] = useState([]);

  const displayAnalyzeSteps = (todo) => {
    let stepsData = [];
    if (todo === 'analyzeCompany') {
      stepsData = [
        { todo: 'searchBusiness', description: '事業内容を調べる' },
        { todo: 'searchBusinessResults', description: '直近の業績について調べる' },
        { todo: 'searchSegmentResults', description: 'セグメント別の業績及びその要因について調べる' },
        { todo: 'searchTimeSeries', description: '業績推移について調べる' },
        { todo: 'searchKPI', description: '企業のKPIを確認する' },
        { todo: 'searchESG', description: '企業のESGに対する取り組みを調べる' },
        { todo: 'compareCompanies', description: '同業他社と企業を比較する' },
      ];
    } else if (todo === 'compareCompanies') {
      stepsData = [
        { todo: 'compareBusiness', description: '事業内容を比較する' },
        { todo: 'compareBusinessResults', description: '直近の業績について比較する' },
        { todo: 'compareSegmentResults', description: 'セグメント別の業績及びその要因について比較する' },
        { todo: 'compareTimeSeries', description: '業績推移について比較する' },
      ];
    }
    setSteps(stepsData);
  };

  useEffect(() => {
    displayAnalyzeSteps(todo);
  }, [todo]);

  return (
    <div className="analysis-steps">
      <div className="prompt-msg"><i className="fa-regular fa-lightbulb"></i>進め方の例です。</div>
      <div className="step-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.todo}>
            <div
              className={`step ${selectedStep === null ? '' : selectedStep === step.todo ? 'selected' : 'unselected'}`}
              data-value={step.todo}
              onClick={() => { onStepClick(step.todo); onButtonClicked(step.todo); }}
            >
              <span className="step-count">Step {index + 1}. </span>
              <span className="description">{step.description}</span>
            </div>
            {index < steps.length - 1 && (
              <div className="right-arrow">
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ShowAnalysisStep;
